import { Box, Stack } from "@mui/material";
import { useLayoutEffect, useRef, useState } from "react";
import SearchField from "@entrilia/shared/components/inputs/SearchField";

interface Props {
  onSearch: (search: string) => void;
}

const Search = ({ onSearch }: Props) => {
  const [isSticky, setIsSticky] = useState(false);
  const sentinelRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) return;

    const rootEl = sentinel.parentElement;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(entry?.isIntersecting === false);
      },
      {
        root: rootEl,
        threshold: 0,
      }
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Box sx={{ width: "100%", height: "1px !important" }} ref={sentinelRef} />
      <Stack
        sx={{
          position: "sticky",
          zIndex: 10,
          top: 0,
          backgroundColor: "background.paper",
          px: 2,
          py: 1.5,
          borderBottom: "1px solid",
          borderColor: "background.paper",
          ...(isSticky && { borderColor: "divider" }),
          transition: "border-color 0.3s ease-in-out",
        }}
      >
        <SearchField placeholder="Search" fullWidth onSearch={onSearch} />
      </Stack>
    </>
  );
};

export default Search;
